<template>
  <div class="bg-white">
    <div class="main-width pb-12">
      <div class="my-5">
        <VBreadcrumb :options="[{ label: '首页', to: '/' }, { label: '原创资讯' }]"></VBreadcrumb>
      </div>
      <PlatformAdvertStairSwiper :items="adStore.state" type="original_home" />
      <h2 class="flex pt-5 pb-3">
        <span class="text-dark font-semibold text-2xl my-2">原创资讯</span>
      </h2>
      <el-row type="flex" class="flex-wrap main-width" :gutter="12">
        <el-col class="mb-3" v-for="item in consultations" :key="item.no" :span="6">
          <consultation-card :report="item" />
        </el-col>
      </el-row>
      <loading-more-btn :pagination="pagination" :isLoading="isLoading" @onLoadMore="onLoadMore" />
    </div>
  </div>
</template>

<script>
import { ref, useFetch,useMeta,defineComponent } from "@nuxtjs/composition-api";
import usePagination from "~/composables/usePagination";
import usePlatformAdvertBanner from '~/composables/usePlatformAdvertBanner'
import { searchCommunity } from "@/services/company";
import ConsultationCard from "@/views/company/ConsultationCard.vue";
import PlatformAdvertStairSwiper from "~/components/product/PlatformAdvertStairSwiper.vue"
import VBreadcrumb from '@/components/VBreadcrumb.vue'
import LoadingMoreBtn from '@/views/company/LoadingMoreBtn.vue';

export default defineComponent({
  name: 'OriginalHome',
  layout: "Main",
  auth: false,
  components: { ConsultationCard, PlatformAdvertStairSwiper, VBreadcrumb, LoadingMoreBtn },
  head:{

  },
  setup() {
    const consultations = ref([]);
    useMeta({
      title: '原创资讯',
      meta: [
        {
          name: 'description',
          content: '【上船吧邮轮平台】为您提供上船吧邮轮行业原创专区内容,专业生产邮轮行业优质内容,邮轮视频内容,邮轮图文内容等',
          hid: 'description'
        },
        {
          name: 'keywords',
          hid: "keywords",
          content: '原创资讯,上船吧邮轮行业原创专区,【上船吧邮轮平台】'
        }
      ]
    });
    const { execute, pagination, isLoading, enabledLoadMore } = usePagination(
      ({ page_index, page_size }) =>
        searchCommunity({
          cate: 'original',
          page_index,
          page_size,
        }),
      undefined,
      { immediate: false }
    );
    pagination.page_size = 52;
    const { fetch } = useFetch(async () => {
      let data = await execute(0, pagination);
      consultations.value = consultations.value.concat(data.list);
    });

    const adStore = ref(usePlatformAdvertBanner(36));

    async function onLoadMore() {
      pagination.page_index += 1;
      fetch()
    }
    return { consultations, pagination, isLoading, onLoadMore, enabledLoadMore, adStore }
  }
});
</script>

<style lang="scss" scoped>

</style>